import { ReactNode, useEffect } from "react";

export interface IModal {
  show: boolean;
  className?: string;
  children?: ReactNode;
  onClose?: () => void;
}

function Modal({ show, className, children, onClose }: IModal) {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [show]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-[9999]">
        {children}
      </div>
  );
}

export default Modal;
